import "./styles/customDatePicker.scss";
import InfoBarSelection from "../CustomSelect/components/InfoBarSelection";
import DateRangePicker from "./components/dateRangePicker";
import React, { Component } from "react";
import { ClickAwayListener } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { format, subDays } from "date-fns";
import CalenderIcon from "./icons/event_calendar.svg";

//import { he } from "date-fns/locale";

export default class CustomDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxSelection: {},
      localValues: [],
      searchTerm: "",
      dialogOpen: false,
    };
  }

  onDateChange = (e) => {
    this.props.onChangeDate({
      target: { key: this.props.item.key, value: e },
    });
    this.setState({ dialogOpen: false });
  };
  render() {
    // ${format(new Date(timeStamp),"h:mm b, cccc, MMMM LL")}
    //console.log(reportKey);
    const item = this.props.item;
    const isRequired = this.props.isRequired ? this.props.isRequired : false;

    const minDate = item.minDate; //"raw-data-report" ? subDays(new Date(), 4) :
    const maxDate = item.maxDate; // reportKey === "raw-data-report"? subDays(new Date(), 2):
    return (
      <div
        className={"dexter-custom-date-container"}
        onClick={(e) => {
          e.stopPropagation();
          this.setState({ dialogOpen: true });
        }}
        style={this.props.style}
      >
        <img src={CalenderIcon} className="calender-icon" />
        <InfoBarSelection
          item={item}
          values={
            item.value === "" ? [] : [new Date(item.value).toDateString()]
          }
          type="date"
          isRequired={isRequired}
        />

        {this.state.dialogOpen && (
          <Dialog
            aria-labelledby="simple-dialog-title"
            open={true}
            onClose={() => this.setState({ dialogOpen: false })}
          >
            <div className="shared-custom-date-picker--container">
              <h2 className="custom-date-picker-header">{item.label}</h2>
              <DateRangePicker
                onChangeDate={this.onDateChange}
                minDate={minDate}
                maxDate={maxDate}
                date={item.value}
              />
            </div>
          </Dialog>
        )}
      </div>
    );
  }
}
